"use strict";
// import CryptoJS from 'crypto-js';
Object.defineProperty(exports, "__esModule", { value: true });
exports.encode = (key, value) => {
    return 'abc';
    // TODO: will this in the future
    // encodeURIComponent(CryptoJS.AES.encrypt(value, key).toString())
};
exports.decode = (key, encryptedData) => {
    const decodedURI = decodeURIComponent(encryptedData);
    return 'abc';
    // const bytes = CryptoJS.AES.decrypt(decodedURI, key);
    // return bytes.toString(CryptoJS.enc.Utf8);
};
//# sourceMappingURL=encrypt.js.map